import * as React from 'react';
import './index.scss';

export default class List extends React.Component {

  render() {
    const { children } = this.props;

    return (
      <div className="media-list">
        {React.Children.map(children, (item) => {
          return <div>{item}</div>
        })}
      </div>
    )
  }
}